import 'sass/blocks/personal-data-view.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import preLoaderActions from 'actions/preLoaderActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { ProfileStepClient1 } from 'components/newAccountSteps/profileSteps/profileStepClient1';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { errorTag } from 'utilities/uTagging';
import { PATH_CONTACT_CLIENT, PATH_ERROR } from 'constants/uTagConstants/paths';
import { formatText, FormattedText } from 'core/i18n';
import UtagHelper from 'utilities/utagHelper';
import Storage from 'utilities/storage';
import cryptoJS from 'crypto-js';
import { PUBLICA_URL } from 'constants/index';

class PersonalDataClientView extends React.Component {
    constructor(props) {
        super(props);

        this.getBatchMessages = this.getBatchMessages.bind(this);
        this.getBatchError = this.getBatchError.bind(this);
    }

    componentDidMount() {
        const { userProfile, products, recordAndSavePage } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        recordAndSavePage(
            PATH_CONTACT_CLIENT,
            userProfile.recordId,
            userProfile.userId,
            userProfile.product,
            products.get('productsDescription'),
            userProfile.promoCode ? userProfile.promoCode : '',
            JointHolderInfo,
            '',
            '',
            userProfile.investmentType,
            {
                identificadorOnboarding: docNumberEncrypted,
            }
        );
    }

    getBatchError() {
        return this.props.errorState.batchError;
    }

    getBatchMessages() {
        const { preLoaderActions } = this.props;
        preLoaderActions.hidePreLoader();
        errorTag('', PATH_ERROR);
        return (
            <MessagesScreen
                iconClass="icons icons--icon-clock-type-2"
                title={formatText('messagesScreen-batchErrorTitle')}
                subtitle={formatText('messagesScreen-batchErrorSubTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={function () {
                    Storage.cookies.remove('accessToken');
                    Storage.cookies.remove('refreshToken');
                    window.location.href = PUBLICA_URL;
                }}
            >
                <FormattedText value="messagesScreen-batchErrorContent" />
                <FormattedText value="messagesScreen-batchErrorContent2" />
                <FormattedText value="messagesScreen-customerServiceDepartment" />
            </MessagesScreen>
        );
    }

    renderProfileOrError() {
        const batch = this.getBatchError();
        if (batch) {
            return <div className="profesional-data-view">{this.getBatchMessages()}</div>;
        }
        return (
            <div className="personal-data-view">
                <ProfileStepClient1 />
                <WelcomeCard />
            </div>
        );
    }

    render() {
        return this.renderProfileOrError();
    }
}

module.exports.constructor = PersonalDataClientView;
module.exports.PersonalDataClientView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(PersonalDataClientView);
